import { createComponent } from '@carvana/merch-components';

export const Container = createComponent('div', {
  className:
    'grid h-[60px] grid-cols-[auto_1fr_auto] items-center gap-x-16 border-b border-grey-2 bg-white px-16 l:h-[72px] l:grid-cols-[auto_auto_1fr_auto] l:gap-x-64 l:px-32'
});

export const Links = createComponent('nav', {
  className: 'hidden grid-flow-col l:grid l:gap-x-32'
});

export const Link = createComponent('a', {
  className: 'text-blue-6 tl-header-s hover:text-blue-3'
});
